import BaseCard from './BaseCard';
import { CardType } from './CardType';

export default class JokerCard extends BaseCard {
    public onCreate(params: any): void {
        params.cardFrontTexture = 'joker';
        params.type = CardType.joker;
        super.onCreate(params);
    }
}
